import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import MaterialTable from 'material-table';
import { Send, AssignmentReturn as Assignment, Edit } from '@material-ui/icons';
import { useHistory, useParams, NavLink } from 'react-router-dom';

import { localization, modifyDefaultOptions, options, tableIconsModified, arrayToLookup } from "../../../../helpers/table";
import { makeUID, styledTable, styledTableHeading, tableIcons, years } from "../../../../helpers";
import ReportStatusBadge from "../../../../components/ReportStatusBadge";
import useAPI from "../../../../hooks/useAPI";
import {
  canEdit,
  canSendForApprove,
  canSendForRevision,
} from "../../../../components/SPReportTabs/reportRegisterDataService";
import useUserContext from "../../../../hooks/useUserContext";
import SendForRevisionModal from "../../../../components/ProjectReportTabs/SendForRevisionModal";
import { statusLabels } from "../../../../helpers/projReportHelper";
import style from './style.module.less'
import {PortfReportsActions} from "../../../../components/common/Actions/PortfDataActions";
import FilterMultiSelect from '../../../../components/table/FilterMultiSelect';

const modifiedYears = [
  ...years.map((val) => ({ value: val, label: val })),
];

const defaultYear = 2023;

function IconSendApprove({ disabled }) {
  return <Send style={{ color: !disabled ? '#ffc107' : undefined }} color={disabled ? 'disabled' : undefined} />;
}
function IconSendRevision({ disabled }) {
  return <Assignment color={disabled ? 'disabled' : 'error'} />;
}
function IconEdit({ disabled }) {
  return <Edit style={{ color: !disabled ? '#ffc107' : undefined }} color={disabled ? 'disabled' : undefined} />;
}

export default function ReportRegisterTab() {
  const { stratId, portfolioId } = useParams();
  const history = useHistory();

  const [tableKey, setTableKey] = useState(makeUID(5));
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [filtersHead, setFiltersHead] = useState(null);
  const [revisionModalReportId, setRevisionModalReportId] = useState(null);
  const [currentYear, setCurrentYear] = useState({ value: defaultYear, label: defaultYear });

  const api = useAPI();
  const userCtx = useUserContext();

  const fetchData = async (year) => {
    if (isLoaded) setIsLoaded(false);
    const yearQuery = year ? `year=${year}&` : '';
    const result = await api.get(`/projs/0/reports?${yearQuery}strategyId=${stratId}&portfId=${portfolioId}`);
    setIsLoaded(true);
    setData(result?.map((e)=>{
      e.headFullName=e?.head?.fullName;
      return e;
    }));
    setFiltersHead(
      result.reduce((acc, item) => {
        if (item.head) return { ...acc, [item.head.id]: item.head.fullName };
        return acc;
      }, {}),
    );
  };

  const handleYearChange = async (val) => {
    setCurrentYear(val);
    await fetchData(val.value); // вызов обновления данных на каждую смену фильтра по годам
  };

  useEffect(async () => {
    await fetchData(currentYear.value);
  }, []);

  const updateReportStatus = async (id, status) => {
    await setData((prev) => prev.map((r) => (r.id === id ? { ...r, reportStatus: status } : r)));
  };

  const handleSendForRevision = async (newComment) => {
    const sendForRevisionResp = await api.post(`/projs/${revisionModalReportId}/results/0/return`, {
      year: currentYear.value,
      comment: newComment,
    });
    if (sendForRevisionResp.error) return;
    await updateReportStatus(revisionModalReportId, sendForRevisionResp.status);
  };

  const columns = [
    {
      title: `Статус отчёта ${currentYear.value}`,
      maxWidth: "250px",
      field: "reportStatus",
      lookup: statusLabels,
      render: (rowData) => (
          <div>
            <ReportStatusBadge status={rowData.reportStatus} />
          </div>
      ),
      filterComponent: FilterMultiSelect,
      customFilterAndSearch: (term, rowData) => {
        if(term.length==0) return true;
        return term.includes(rowData.reportStatus)
      },
    },

    { title: "№", field: "fullNumber", filterCellStyle: { width: "7%" } },
    {
      title: 'Наименование проекта',
      filterCellStyle: { width: '800px' },
      field: 'name',
      render: (rowData) => (
        <NavLink to={`/strats/${stratId}/portfolios/${portfolioId}/projs/${rowData.id}/yearReport/year/${currentYear.value}`}>
          {rowData.name}
        </NavLink>
      ),
    },
    {
      title: "Руководитель проекта",
      field: "headFullName",
      lookup: arrayToLookup("headFullName", data),
      render: (rowData) => rowData.headFullName,
      filterComponent: FilterMultiSelect,
    },
  ];

  if (!isLoaded) {
    return (
      <section className="tab-agreement">
        <div>Загрузка...</div>
      </section>
    );
  } else
    return (
      <section>
        <div>
          <MaterialTable
            title={<div style={{ minWidth: "144px", marginBottom:"32px" }}>
              <div style={{ color: "black", fontSize: "16px", marginBottom: "10px", fontWeight: "600" }}>Год</div>
              <Select
                placeholder="Выберите год"
                name="yearsSingle"
                options={modifiedYears}
                onChange={handleYearChange}
                value={currentYear}
                isSearchable={false}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 100500 }) }}
              />
            </div>}
            key={tableKey}
            options={modifyDefaultOptions({
              actionsColumnIndex: 0,
              search: false,
              toolbar: true,
            })}
            actions={[{}]}
            components={{
              Container: (props) => <div className={'special-filter-without-max'} {...props}/>,
              Actions: (props) => {
                return props.data ? (
                  <PortfReportsActions
                    userCtx={userCtx}
                    props={props.data || false}
                    actions={{
                      send: () => {
                        setRevisionModalReportId(props.data.id);
                      },
                      edit: () =>
                        history.push(
                          `/strats/${stratId}/portfolios/${portfolioId}/projs/${props.data.id}/yearReport/year/2022`
                        ),
                    }}
                  />
                ) : null;
              },
            }}
            icons={tableIconsModified}
            localization={localization}
            columns={columns}
            data={data}
          />
        </div>
      <SendForRevisionModal
        show={revisionModalReportId}
        onSubmit={handleSendForRevision}
        onClose={() => setRevisionModalReportId(null)}
      />
    </section>
  );
}
